import React, { useEffect, useState } from "react";
import AppLayout from "../components/AppLayout";
import CVEditor from "../components/CVEditor";
import CVImportCard from "../components/CVImportCard";
import { api } from "../lib/api";

export default function CoacheeCVPage() {
  const [coacheeId, setCoacheeId] = useState(null);
  const [loading, setLoading] = useState(true);
  // True zodra de coachee ooit een CV heeft geupload via de AI-import.
  // Op dat moment verbergen we de "Heb je al een CV?" upload-kaart, want
  // hun CV is dan al binnen — verdere wijzigingen gaan via de editor.
  const [hasImported, setHasImported] = useState(false);
  // Bumpen we deze key, dan herinitialiseert CVEditor zichzelf en haalt
  // de verse CV-data op — dit is hoe we de import "doortrekken" naar het
  // formulier zonder CVEditor zelf aan te passen.
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const { data: coachees } = await api.get("/coachees");
        if (!Array.isArray(coachees) || coachees.length === 0) return;
        const cid = coachees[0].id;
        setCoacheeId(cid);
        try {
          const { data: cv } = await api.get(`/coachees/${cid}/cv`);
          if (cv?.imported_at) setHasImported(true);
        } catch (err) {
          console.warn("CV lookup failed:", err?.message || err);
        }
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const handleImported = () => {
    // We verbergen de import-kaart NIET meteen na een geslaagde import,
    // omdat de kaart zelf de groene "geïmporteerd"-bevestiging toont.
    // Bij de volgende paginabezoek leest de GET /cv `imported_at` uit en
    // wordt de kaart automatisch verborgen.
    setRefreshKey((k) => k + 1);
  };

  return (
    <AppLayout title="Mijn CV" breadcrumbs={[{ label: "Mijn CV" }]}>
      {loading ? (
        <div className="text-zinc-500">Laden...</div>
      ) : !coacheeId ? (
        <div className="text-zinc-500">Geen CV-profiel gevonden.</div>
      ) : (
        <>
          {!hasImported && (
            <CVImportCard
              coacheeId={coacheeId}
              onImported={handleImported}
            />
          )}
          <CVEditor key={refreshKey} coacheeId={coacheeId} />
        </>
      )}
    </AppLayout>
  );
}
